import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '980839301047199';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFbq() {
  if (window.fbq) return;
  const fbq = function (...args: any[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue.push(args);
    }
  } as any;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
}
function loadScript(): Promise<void> {
  return new Promise(resolve => {
    if (document.querySelector('script[src*="fbevents.js"]')) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });
}
export function useMetaPixel() {
  useEffect(() => {
    initFbq();
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    loadScript();
    // Add noscript fallback pixel
    if (!document.querySelector('img[data-fb-pixel]')) {
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.setAttribute('data-fb-pixel', 'true');
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      document.body.appendChild(img);
    }
  }, []);
}
export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Bochornos a Raya - Protocolo de 14 Días',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  }
}